export enum EVolumeAndClicksMetric {
    VOLUME = "volume",
    CLICKS = "clicks",
    ZERO_CLICKS = "zeroClicks",
}

export interface IDeviceTraffic {
    Desktop: number;
    Mobile: number;
}

interface IMonthToVisits {
    [date: string]: IDeviceTraffic;
}

export interface IClicksData {
    MonthToVisits: IMonthToVisits;
    TotalClicks: number;
}

export interface IClicksResponseData {
    Data: {
        [keyword: string]: IClicksData;
    };
}

export interface IMonthlyData {
    [date: string]: number;
}

interface IVolumeAndNoClicksData {
    VolumesMonthly: IMonthlyData[];
    Volume: number;
    MobileShareMonthly: IMonthlyData[];
    MobileShare: number;
    ZeroClicksMonthly: IMonthlyData[];
    ZeroClicksYearlyAverage: number;
}

export interface IVolumeAndNoClicksResponseData {
    Data: {
        [keyword: string]: IVolumeAndNoClicksData;
    };
}

export interface IVolumeAndNoClicksRowData {
    volumeRowData: { value: number; change: number };
    zeroClicksRowData: { value: number; change: number };
}

export interface IClicksRowData {
    clicksRowData: { value: number; change: number };
}
